import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'
import { Tokens } from '@tmov/design-system/theme/types'

import RG from 'shared/assets/images/rg.png'
import CNH from 'shared/assets/images/cnh.jpeg'

export { Button, Heading, Paragraph } from '@tmov/design-system'

const { colors } = Tokens.eixods

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
  margin: 40px auto 0;
`

export const Document = styled.div`
  max-width: 1000px;
  width: 100%;
  max-height: 600px;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: space-between;
  & h3 {
    color: ${colors.brand.secondary[100]};
  }
  & > div {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    text-align: center;
    & h4 {
      color: ${colors.brand.secondary[100]};
      width: 100%;
    }
    & p {
      color: ${colors.neutral.grey[70]};
      max-width: 600px;
      margin: 0 auto;
    }
  }
`

export const Doc = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
`

export const ImgRG = styled.img.attrs({
  src: RG,
})`
  width: 80%;
  padding: 60px 0;
`

export const ImgCNH = styled.img.attrs({
  src: CNH,
})`
  width: 40%;
`

export const Action = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 24px;
  button {
    width: 120px;
  }
`
